import { Routes } from '@angular/router';
import { adminGuard } from './guards/admin.guard';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';

export const adminRoutes: Routes = [
  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivate: [adminGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/admin-dashboard/admin-dashboard.component').then(
            m => m.AdminDashboardComponent
          ),
        data: { breadcrumb: [{ label: 'Dashboard' }] },
      },
      {
        path: 'tenants',
        loadComponent: () =>
          import('./features/admin-tenants/admin-tenants.component').then(
            m => m.AdminTenantsComponent
          ),
        data: { breadcrumb: [{ label: 'Tenants' }] },
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./features/admin-users/admin-users.component').then(
            m => m.AdminUsersComponent
          ),
        data: { breadcrumb: [{ label: 'Usuários' }] },
      },
      {
        path: 'queues',
        loadComponent: () =>
          import('./features/admin-queues/admin-queues.component').then(
            m => m.AdminQueuesComponent
          ),
        data: { breadcrumb: [{ label: 'Filas' }] },
      },
      {
        path: 'schedules',
        loadComponent: () =>
          import('./features/admin-schedules/admin-schedules.component').then(
            m => m.AdminSchedulesComponent
          ),
        data: { breadcrumb: [{ label: 'Agendamentos' }] },
      },
      {
        path: 'platforms',
        loadComponent: () =>
          import('./features/admin-platforms/admin-platforms.component').then(
            m => m.AdminPlatformsComponent
          ),
        data: { breadcrumb: [{ label: 'Plataformas' }] },
      },
      {
        path: 'logs',
        loadComponent: () =>
          import('./features/admin-logs/admin-logs.component').then(
            m => m.AdminLogsComponent
          ),
        data: { breadcrumb: [{ label: 'Logs' }] },
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },
];
